(function (angular, app) {
   "use strict";

   // UIFactory
   angular.module(app.modules.invitation.name)
      .factory(app.modules.invitation.services.invite, InvitationsFactory);

   // Injector
   InvitationsFactory.$inject = [
      app.modules.common.constants.appsettings
      , app.modules.common.services.functions
      , app.modules.common.services.http
   ];

   // Function
   function InvitationsFactory(ggSettings, ggFunctions, $http) {

      //##//--------------------------------------- 
      var _responseTypes = {
         noresponse: "NoResponse"
         , accept: "Accepted"
         , reject : "Rejected"
      }

      var _invite = {
         insertInvitation: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.invitation.detail;
            var form = {};

            if (!data.groupId && !data.outingId) {
               form.type = "Generic";
            } else {

               if (data.outingId) {
                  form.outingId = data.outingId;
                  form.type = "Outing";
               }

               if (data.groupId) {
                  form.groupId = data.groupId;
                  form.type = "Group";
               }
            }

            form.createdById = app.Member.Detail.id;
            form.firstName = data.firstName;
            form.lastName = data.lastName;

            if (data.memberId) {
               form.memberId = data.memberId;
            }
            if (data.email) {
               form.email = data.email;
            }

            if (data.responseType) {
               form.responseType = data.responseType;
            }

            

            // Post the data, but don't transform it.
            return $http.post(apipath, form, false);
         }
         , updateInvitationResponse: function (data) {

            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.invitation.detail + "("+data.id+")";
            var form = {};
            form.responseType = data.responseType;
            form.responseOn = new Date();
            form.memberId = data.memberId; // The current member

            if (data.outingId) {
               form.outingId = data.outingId
            }

            return $http.put(apipath, form);
         }
      }

      var _search = {
         fetchInvitations: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.invitation.detail;
            var qry = "";
            var exp = "";
            var is = false;

            if (data.memberId && data.memberId > 0 && data.email && data.email != '') {
               if (is) {
                  qry += " and "
               }
               qry += "(memberId eq " + data.memberId + " or email eq '" + data.email + "')";
               is = true;
            } else {
               if (data.memberId && data.memberId > 0) {
                  if (is) {
                     qry += " and "
                  }
                  qry += " memberId eq " + data.memberId;
                  is = true;
               }
               if (data.email && data.email != '') {
                  if (is) {
                     qry += " or "
                  }
                  qry += " email eq '" + data.email + "'";
                  is = true;
               }
            }

            if (data.expiresOn) {
               if (is) {
                  qry += " and "
               }
               qry += " expiresOn gt " + ggFunctions.formatDateString(data.expiresOn, 'yyyy-mm-dd', null);
               is = true;
            }

            if (data.groupId && data.groupId > 0) {
               if (is){
                  qry += " and "
               }
               qry += " groupId eq " + data.groupId;
               is = true;
            }
            
            if (data.outingId && data.outingId > 0) {
               if (is) {
                  qry += " and "
               }
               qry += " outingId eq " + data.outingId;
               is = true;
            }
            
            if (data.responseType && data.responseType != '') {
               if (is) {
                  qry += " and "
               }
               qry += " responseType eq " + ggSettings.grpapi.namespace + ".InvitationResponseType'" + data.responseType + "'";
               is = true;
            } else {
                if (is) {
                    qry += " and "
                }
                qry += " responseType eq " + ggSettings.grpapi.namespace + ".InvitationResponseType'NoResponse'";
                is = true;
            }

            if (data.type && data.type == 'Group') {
               if (is) {
                  qry += " and "
               }
               qry += " type eq  " + ggSettings.grpapi.namespace + "'Group'";
               is = true;
            }
            if (data.type && data.type == 'Outing') {
               if (is) {
                  qry += " and "
               }
               qry += " type eq  " + ggSettings.grpapi.namespace + "'Outing'";
               is = true;
            }
            if (data.token) {
               if (is) {
                  qry += " and "
               }
               qry += "id eq "+data.token+"";
               is = true;
            }

           

            if (is) {
               qry = "?$filter=" + qry;
            }

            exp = "&$expand=createdBy($select=firstName,lastName,gender),group($select=name,isActive,isPrivate,themeId),outings($select=name,themeId,startOn,endOn)&$orderby=createdOn+desc"

            return $http.get(apipath + qry + exp, { ignoreLoadingBar: true });
         }
         , fetchInvitationDetail: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.invitation.detail + "("+data.invitationId+")";
            var qry = "";
            var exp = "?$expand=createdBy($select=firstName,lastName,gender),group($select=name,isActive,isPrivate,themeId),outings($select=name,themeId,startOn,endOn)"

            return $http.get(apipath + qry + exp, {});
         }
      }

      //##//--------------------------------------- 

      // Public
      var service = {
         invitation: null // store temp group here
         , search: _search
         , invite: _invite
         , responseTypes : _responseTypes
      }

      return service;

   }
}(angular, app));




